/* Drawer zakupu na kartach stylów - warstwa nad konfiguratorem C+ (GMC Faza 3).
   Dane z data-atrybutów sekcji knf-karta-zakup; do koszyka trafia wariant
   konfiguratora front-ikea z properties w formacie konfiguratora. */
(function () {
  'use strict';
  const root = document.querySelector('[data-knf-karta]');
  if (!root) return;

  const cfg = JSON.parse(root.dataset.config);        // {styl, stawka, kategoria, warianty:{"0.10":[id,pln,eur],...}, styl_en, styl_de, styl_cs}
  const dims = JSON.parse(root.dataset.dims);          // {METOD:{Drzwi:[{label,szer_mm,wys_mm,bestseller}...]}}
  const colors = JSON.parse(root.dataset.colors);      // [{name,hex,...}] lub null (fornir/sklejka)
  const locale = root.dataset.locale || 'pl';
  const currency = root.dataset.currency || 'PLN';
  const T_SELECT = root.dataset.tSelect;
  // Grubość, dozwolone typy i opcje stylu z metafieldów front-ikea (snippets/knf-karta-opcje.liquid,
  // w tym samym bloku custom-liquid co panel). Brak elementu = pozycja bez grubości i opcji stylu.
  let opcjeCfg = null;
  try {
    const el = document.querySelector('[data-knf-karta-opcje]');
    if (el) opcjeCfg = JSON.parse(el.textContent);
  } catch (_) { opcjeCfg = null; }

  const drawer = root.querySelector('[data-knf-karta-drawer]');
  const selSys = root.querySelector('[data-knf-karta-system]');
  const selTyp = root.querySelector('[data-knf-karta-typ]');
  const selDim = root.querySelector('[data-knf-karta-dim]');
  const selColor = root.querySelector('[data-knf-karta-color]');
  const priceEl = root.querySelector('[data-knf-karta-price]');
  const addBtn = root.querySelector('[data-knf-karta-add]');
  // 24.09 (wer3): drzwi w stylu z uchwytem wymagaja strony zawiasow, a drzwi przedluzane - strony przedluzenia.
  // Szuflada karty ma tylko wymiary standardowe i tych wyborow nie ma - wtedy przycisk otwiera konfigurator z ta sama konfiguracja.
  const CFG_URL = (root.querySelector('.knf-karta__cfg') || {}).getAttribute ? root.querySelector('.knf-karta__cfg').getAttribute('href').split('?')[0] : '/products/front-ikea';
  const NEED_T = {
    hinge: { pl: 'Wybierz zawiasy w konfiguratorze', en: 'Choose hinges in the configurator', de: 'Scharniere im Konfigurator wählen', cs: 'Vyberte panty v konfigurátoru' },
    ext: { pl: 'Wybierz przedłużenie w konfiguratorze', en: 'Choose extension in the configurator', de: 'Verlängerung im Konfigurator wählen', cs: 'Vyberte prodloužení v konfigurátoru' },
    pair: { pl: 'Dodaj parę A+B w konfiguratorze', en: 'Add the A+B pair in the configurator', de: 'A+B-Paar im Konfigurator hinzufügen', cs: 'Přidejte pár A+B v konfigurátoru' }
  };
  // 09.10.2026 (audyt): jak konfigurator - FAKTUM „A+B (2-frontowe)” = para (2 szt., cena za parę), METOD „Drzwi narożne” 25×80
  // = drzwi łamane A i B (dwie pozycje, tylko przez konfigurator), panele/cokoły/listwy bez uchwytu, cokół i element < 10 cm w drewnie ze słojami wzdłuż.
  const PAIR_T = { pl: 'para A+B', en: 'pair A+B', de: 'Paar A+B', cs: 'pár A+B' };
  const abPairTyp = (typ) => /^A\+B/.test(typ || '');
  const kitPair = (sys, typ, d) => sys === 'METOD' && typ === 'Drzwi narożne' && !!d && d.szer_mm === 254 && d.wys_mm === 797;
  const pairOf = (sys, typ, d) => abPairTyp(typ) || kitPair(sys, typ, d);
  const noHandleTyp = (typ) => /^(Panel|Cok[oó]ł|Listwa|Blenda)/.test(typ || '');
  function forcedGrain(typ, d) {
    if ((cfg.kategoria || 'lakier') === 'lakier' || !d) return '';
    if (/^Cok[oó]ł/.test(typ || '')) return 'Poziomy';
    const s = d.szer_mm, w = d.wys_mm;
    return s > 0 && w > 0 && s !== w && Math.min(s, w) < 100 ? (w < s ? 'Poziomy' : 'Pionowy') : '';
  }
  function needsCfg() {
    const typ = selTyp.value || '';
    const hasHandle = !!(opcjeCfg && Array.isArray(opcjeCfg.opcje) && opcjeCfg.opcje.some(o => o.label === 'Lokalizacja uchwytu'));
    if (kitPair(selSys.value, typ, currentDim())) return 'pair';
    if (typ === 'Drzwi przedłużane') return 'ext';
    if (hasHandle && /^(Drzwi|Korpus wysoki|Przedłużone|A\+B)/.test(typ)) return 'hinge';
    return '';
  }

  // Tłumaczenia typów elementów - te same nazwy co konfigurator (PL w danych).
  const TYP_I18N = {
    'Drzwi': { en: 'Door', de: 'Tür', cs: 'Dveře' },
    'Szuflada': { en: 'Drawer', de: 'Schublade', cs: 'Zásuvka' },
    'Panele boczne': { en: 'Side panels', de: 'Seitenpaneele', cs: 'Boční panely' },
    'Cokoły': { en: 'Plinths', de: 'Sockelblenden', cs: 'Sokly' },
    'Drzwi przedłużane': { en: 'Extended doors', de: 'Verlängerte Türen', cs: 'Prodloužené dveře' },
    'Przedłużone': { en: 'Extended', de: 'Verlängert', cs: 'Prodloužené' },
    'Cargo': { en: 'Cargo', de: 'Cargo', cs: 'Cargo' },
    'Front zmywarki bez nawiertów': { en: 'Dishwasher front (no drilling)', de: 'Geschirrspülerfront (ohne Bohrung)', cs: 'Front myčky (bez vrtání)' },
    'Listwa maskująca': { en: 'Trim panel', de: 'Blende', cs: 'Krycí lišta' },
    'Drzwi narożne': { en: 'Corner doors', de: 'Ecktüren', cs: 'Rohové dveře' },
    'Horyzontalne szafki': { en: 'Horizontal cabinets', de: 'Horizontale Schränke', cs: 'Horizontální skříňky' },
    'A+B (2-frontowe)': { en: 'A+B (2 fronts)', de: 'A+B (2 Fronten)', cs: 'A+B (2 čela)' },
    'Korpus wysoki': { en: 'Tall cabinet', de: 'Hochschrank', cs: 'Vysoká skříň' },
    'Drzwi poziome': { en: 'Horizontal doors', de: 'Horizontale Türen', cs: 'Vodorovné dveře' },
    'Panele maskujące': { en: 'Cover panels', de: 'Abdeckpaneele', cs: 'Krycí panely' },
    'Panel gięty ślepy R150': { en: 'Curved blind panel R150', de: 'Gebogenes Blindpaneel R150', cs: 'Ohýbaný slepý panel R150' }
  };
  const tTyp = (pl) => locale === 'pl' ? pl : (TYP_I18N[pl] && TYP_I18N[pl][locale]) || pl;
  const stylTr = cfg['styl_' + locale] || cfg.styl;

  function billedM2(szer, wys) {
    const exact = szer * wys / 1e6;
    return Math.max(0.1, Math.ceil(exact * 20) / 20);
  }
  function variantFor(billed) {
    return cfg.warianty[billed.toFixed(2)] || null; // [id, pln, eur]
  }
  function fmtAmount(amount) {
    const cur = currency === 'EUR' ? 'EUR' : 'PLN';
    return new Intl.NumberFormat(locale === 'pl' ? 'pl-PL' : locale, { style: 'currency', currency: cur }).format(amount);
  }
  function fmtPrice(v) {
    return fmtAmount(currency === 'EUR' ? parseFloat(v[2]) : parseFloat(v[1]));
  }
  // Promocja procentowa na fronty (window.knfPromo z snippets/promo-js.liquid, tylko gdy trwa).
  // Rabat liczony jak automatyczny rabat Shopify: na sztuce, cena × % / 100 obcięte w dół do grosza.
  const PROMO = (window.knfPromo && window.knfPromo.pct > 0 && Date.now() <= window.knfPromo.untilTs) ? window.knfPromo : null;
  const omnibusEl = root.querySelector('[data-knf-karta-omnibus]');
  function promoAmount(amount, pct = PROMO.pct) {
    const cents = Math.round(amount * 100);
    return (cents - Math.floor(cents * pct / 100)) / 100;
  }
  // Omnibus („najniższa cena z 30 dni przed obniżką"): domyślnie cena regularna. cfg.omnibus (knf_config,
  // stawka podniesiona W TRAKCIE promocji, np. Orzech i Korzeń Silver 18.09.2026): cena promocyjna od STAREJ
  // ceny wariantu (omnibus.warianty[m²] = [pln, eur]) do daty omnibus.until; potem wraca regularna.
  function omnibusAmount(amount, billed) {
    const o = cfg.omnibus;
    // Niesparsowalna data (NaN) = brak nadpisania, tak samo jak w konfiguratorze.
    const ts = o && o.until ? Date.parse(o.until + 'T23:59:59+02:00') : 0;
    if (!o || !o.warianty || !(ts > 0 && Date.now() <= ts)) return amount;
    const old = o.warianty[billed.toFixed(2)];
    if (!old) return amount;
    // Procent z omnibus.pct (przy jakiej promocji obowiązywała najniższa cena), nie z bieżącej promocji.
    const pct = Number(o.pct) > 0 ? Number(o.pct) : PROMO.pct;
    return promoAmount(currency === 'EUR' ? parseFloat(old[1]) : parseFloat(old[0]), pct);
  }
  function fill(select, entries, placeholder) {
    select.innerHTML = '';
    if (placeholder) {
      const o = document.createElement('option');
      o.value = ''; o.textContent = placeholder; o.disabled = true; o.selected = true;
      select.appendChild(o);
    }
    for (const [val, label] of entries) {
      const o = document.createElement('option');
      o.value = val; o.textContent = label;
      select.appendChild(o);
    }
  }

  // Typy jak w konfiguratorze: bez panelu giętego R150 (cena stała za wysokość, szuflada ma tylko
  // warianty za m²; w konfiguratorze ukryty od 17.09.2026) i tylko allowed_types stylu (Witryna = Drzwi).
  const allowedTypes = opcjeCfg && Array.isArray(opcjeCfg.allowed_types) && opcjeCfg.allowed_types.length ? opcjeCfg.allowed_types : null;
  const typyFor = (sys) => Object.keys(dims[sys] || {})
    .filter(t => t !== 'Panel gięty ślepy R150' && (!allowedTypes || allowedTypes.includes(t)));

  const systems = Object.keys(dims).filter(s => typyFor(s).length);
  fill(selSys, systems.map(s => [s, s]));
  if (systems.includes('METOD')) selSys.value = 'METOD';

  function refreshTyp() {
    const sys = selSys.value;
    const typy = typyFor(sys);
    fill(selTyp, typy.map(t => [t, tTyp(t)]));
    if (typy.includes('Drzwi')) selTyp.value = 'Drzwi';
    refreshDim();
  }
  function refreshDim() {
    const sys = selSys.value, typ = selTyp.value;
    const list = (dims[sys] && dims[sys][typ]) || [];
    const entries = list.map((d, i) => {
      const star = d.bestseller ? ' ★ ' + root.dataset.tBestseller : '';
      const pair = pairOf(sys, typ, d) ? ' · ' + (PAIR_T[locale] || PAIR_T.pl) : '';
      return [String(i), d.label + pair + star];
    });
    fill(selDim, entries, T_SELECT);
    // default: pierwszy bestseller
    const bi = list.findIndex(d => d.bestseller);
    if (bi >= 0) { selDim.value = String(bi); }
    refreshPrice();
  }
  function currentDim() {
    const sys = selSys.value, typ = selTyp.value;
    const list = (dims[sys] && dims[sys][typ]) || [];
    const i = parseInt(selDim.value, 10);
    return isNaN(i) ? null : list[i];
  }
  function refreshPrice() {
    const d = currentDim();
    const billed = d ? billedM2(d.szer_mm, d.wys_mm) : 0;
    const v = d ? variantFor(billed) : null;
    const colorOk = !selColor || selColor.value;
    if (d && v && colorOk) {
      const n = pairOf(selSys.value, selTyp.value, d) ? 2 : 1;   // para A+B: cena za 2 fronty
      const times = (a) => Math.round(a * n * 100) / 100;
      if (PROMO) {
        const amount = currency === 'EUR' ? parseFloat(v[2]) : parseFloat(v[1]);
        priceEl.innerHTML = `<s class="knf-karta__price-old">${fmtAmount(times(amount))}</s>${fmtAmount(times(promoAmount(amount)))}`;
        if (omnibusEl) { omnibusEl.textContent = `${PROMO.omnibus}: ${fmtAmount(times(omnibusAmount(amount, billed)))}`; omnibusEl.hidden = false; }
      } else {
        priceEl.textContent = n === 1 ? fmtPrice(v) : fmtAmount(times(currency === 'EUR' ? parseFloat(v[2]) : parseFloat(v[1])));
      }
      addBtn.disabled = false;
    } else {
      priceEl.textContent = '-';
      if (omnibusEl) omnibusEl.hidden = true;
      addBtn.disabled = true;
    }
    if (addBtn.dataset.t0 === undefined) addBtn.dataset.t0 = addBtn.textContent;
    const need = needsCfg();
    addBtn.textContent = need ? (NEED_T[need][locale] || NEED_T[need].pl) : addBtn.dataset.t0;
  }

  if (selColor && colors) {
    fill(selColor, colors.map(c => [c.name, c['name_' + locale] || c.name]), T_SELECT);
    const white = colors.find(c => /9016/.test(c.name));
    if (white) selColor.value = white.name;
    selColor.addEventListener('change', refreshPrice);
  }
  selSys.addEventListener('change', refreshTyp);
  selTyp.addEventListener('change', refreshDim);
  selDim.addEventListener('change', refreshPrice);
  refreshTyp();

  root.querySelector('[data-knf-karta-open]').addEventListener('click', () => drawer.showModal());
  root.querySelector('[data-knf-karta-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', (e) => { if (e.target === drawer) drawer.close(); });

  addBtn.addEventListener('click', async () => {
    const d = currentDim();
    if (!d) return;
    if (needsCfg()) {
      const q = new URLSearchParams({ style: cfg.styl, system: selSys.value, typ: selTyp.value, szer: String(d.szer_mm), wys: String(d.wys_mm) });
      if (colors && selColor && selColor.value) q.set('kolor', selColor.value);
      window.location.href = CFG_URL + '?' + q.toString();
      return;
    }
    const billed = billedM2(d.szer_mm, d.wys_mm);
    const v = variantFor(billed);
    if (!v) return;
    const sys = selSys.value, typ = selTyp.value;
    const szerCm = Math.round(d.szer_mm / 10), wysCm = Math.round(d.wys_mm / 10);
    const wymiar = `${szerCm}×${wysCm} cm (${d.szer_mm}×${d.wys_mm} mm)`;
    const kolorPl = colors && selColor ? selColor.value : 'Naturalne drewno';
    const kolorObj = colors && selColor ? colors.find(c => c.name === selColor.value) : null;
    const kolorTr = kolorObj ? (kolorObj['name_' + locale] || kolorObj.name) : root.dataset.natural;
    const L = {
      pl: { front: 'Front', kolor: 'Kolor', syst: 'System / Typ', opcje: 'Opcje', jedno: 'Jednostronnie', polmat: 'Półmat', grubosc: 'Grubość' },
      en: { front: 'Front', kolor: 'Color', syst: 'System / Type', opcje: 'Options', jedno: 'Single-sided', polmat: 'Semi-matt', grubosc: 'Thickness' },
      de: { front: 'Front', kolor: 'Farbe', syst: 'System / Typ', opcje: 'Optionen', jedno: 'Einseitig', polmat: 'Halbmatt', grubosc: 'Stärke' },
      cs: { front: 'Čelo', kolor: 'Barva', syst: 'Systém / Typ', opcje: 'Možnosti', jedno: 'Jednostranně', polmat: 'Polomatný', grubosc: 'Tloušťka' }
    }[locale] || null;
    const P = L || { front: 'Front', kolor: 'Kolor', syst: 'System / Typ', opcje: 'Opcje', jedno: 'Jednostronnie', polmat: 'Półmat', grubosc: 'Grubość' };
    // Opcje jak w konfiguratorze przy nieruszonych polach: Pół-mat (lakier, cena bazowa bez połysku),
    // jednostronnie, domyślne opcje stylu (np. Lokalizacja uchwytu: Góra), grubość stylu.
    const opcjeDefs = (opcjeCfg && Array.isArray(opcjeCfg.opcje)) ? opcjeCfg.opcje : [];
    const opcjeTr = [], opcjePl = [];
    if ((cfg.kategoria || 'lakier') === 'lakier' || opcjeDefs.some(o => o.label === 'Wykończenie')) {
      opcjeTr.push(P.polmat); opcjePl.push('Pół-mat');
    }
    opcjeTr.push(P.jedno); opcjePl.push('Jednostronnie');
    for (const o of opcjeDefs) {
      // Wykończenie wyżej; słoje przechodzące "Nie" konfigurator pomija
      if (!o.default || o.label === 'Wykończenie' || o.label === 'Słoje przechodzące między frontami (+20%)') continue;
      if (o.label === 'Lokalizacja uchwytu' && noHandleTyp(typ)) continue;
      const val = (o.label === 'Kierunek usłojenia' && forcedGrain(typ, d)) || o.default;
      const i = (o.values || []).indexOf(val);
      opcjeTr.push(`${o.label_loc || o.label}: ${(o.values_loc && o.values_loc[i]) || val}`);
      opcjePl.push(`${o.label}: ${val}`);
    }
    const gr = opcjeCfg && Number(opcjeCfg.thickness_mm) > 0 ? Number(opcjeCfg.thickness_mm) : null;
    if (gr) { opcjeTr.push(`${P.grubosc}: ${gr} mm`); opcjePl.push(`Grubość: ${gr} mm`); }
    const fd = new FormData();
    fd.set('id', String(v[0]));
    const qty = abPairTyp(typ) ? 2 : 1;
    fd.set('quantity', String(qty));
    fd.set(`properties[${P.front}]`, `${stylTr} · ${wymiar}`);
    fd.set(`properties[${P.kolor}]`, kolorTr);
    fd.set(`properties[${P.syst}]`, `${sys} · ${tTyp(typ)}`);
    fd.set(`properties[${P.opcje}]`, opcjeTr.join(' · '));
    // Pola dla produkcji Pro-Hand (prefiks "_" = ukryte w koszyku), jak w konfiguratorze
    fd.set('properties[_wys_mm]', String(d.wys_mm));
    fd.set('properties[_szer_mm]', String(d.szer_mm));
    if (gr) fd.set('properties[_grubosc_mm]', String(gr));
    // _pl_summary zawsze (też na PL) i z etykietami - templatka Order Printer czyta segmenty po prefiksie
    fd.set('properties[_pl_summary]', `Front: ${cfg.styl} · ${wymiar} | Kolor: ${kolorPl} | System / Typ: ${sys} · ${typ} | Opcje: ${opcjePl.join(' · ')}`);
    if (root.dataset.knfSubmitting === '1') return;
    const orig = addBtn.textContent;
    root.dataset.knfSubmitting = '1';
    addBtn.disabled = true;
    addBtn.textContent = root.dataset.tAdding;
    // Most do koszyka Horizona (knf-cart-bridge.js): natywne zdarzenie zamiast martwego
    // cart:refresh, szuflada przez theme-drawer po jego zdefiniowaniu. Bez mostu: sam POST
    // i przekierowanie na /cart (klient zawsze widzi, że pozycja weszła).
    const bridge = window.knfCart || null;
    const rootPath = (bridge && bridge.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let sections = null;
    try {
      if (bridge) { fd.set('sections', bridge.sectionId); fd.set('sections_url', window.location.pathname); }
      const r = await fetch(rootPath + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      let body = null;
      try { body = await r.json(); } catch (_) { /* nie-JSON */ }
      if (!r.ok || !body || body.status) throw new Error('status_' + r.status);
      sections = body.sections || null;
    } catch (e) {
      delete root.dataset.knfSubmitting;
      addBtn.textContent = root.dataset.tErr;
      setTimeout(() => { addBtn.textContent = orig; addBtn.disabled = false; }, 2500);
      return;
    }
    // Sukces: od tego miejsca nic nie pokazuje błędu
    delete root.dataset.knfSubmitting;
    addBtn.textContent = orig;
    addBtn.disabled = false;
    drawer.close();
    if (bridge) {
      await bridge.afterAdd(root, { variantId: String(v[0]), qty, sections });
    } else {
      window.location.href = rootPath + 'cart';
    }
  });
})();
